module.exports = __webpack_public_path__ + "img/content-img3_2.4b059d83.png";